import { useState, useEffect } from "react";

interface IUseDebounce {
  value: string;
  delay: number;
}

const useDebounce = ({ value, delay }: IUseDebounce) => {
  const [debounceVal, setDebounceVal] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceVal(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debounceVal;
};

export default useDebounce;
